var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59403 3.97009H0.238657V2.97009H8.59403V3.97009Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.011 6.22009C12.5298 6.22009 13.761 4.98887 13.761 3.47009C13.761 1.95131 12.5298 0.720093 11.011 0.720093C9.49224 0.720093 8.26102 1.95131 8.26102 3.47009C8.26102 4.98887 9.49224 6.22009 11.011 6.22009ZM11.011 5.15273C11.9403 5.15273 12.6936 4.3994 12.6936 3.47011C12.6936 2.54083 11.9403 1.7875 11.011 1.7875C10.0817 1.7875 9.32839 2.54083 9.32839 3.47011C9.32839 4.3994 10.0817 5.15273 11.011 5.15273Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40572 13.0299H13.7611V12.0299H5.40572V13.0299Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98873 15.2799C1.46995 15.2799 0.238737 14.0487 0.238737 12.5299C0.238737 11.0111 1.46995 9.77991 2.98873 9.77991C4.50752 9.77991 5.73873 11.0111 5.73873 12.5299C5.73873 14.0487 4.50752 15.2799 2.98873 15.2799ZM2.98875 14.2125C2.05946 14.2125 1.30613 13.4592 1.30613 12.5299C1.30613 11.6006 2.05946 10.8473 2.98875 10.8473C3.91803 10.8473 4.67136 11.6006 4.67136 12.5299C4.67136 13.4592 3.91803 14.2125 2.98875 14.2125Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilIcon);
export default __webpack_public_path__ + "static/media/mobil-icon.c18b4f357e5344fa83de1e9118b793de.svg";
export { ForwardRef as ReactComponent };